import React, {  useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './SportBonusPlus.module.css'
import { fetchSportBonus, selectBonusAmount, selectSportBonusStatus, selectSportTypes } from '../sportBonusSlice'
import { postOpenSportBonusPromo } from '../../api/live'

const SportBonusPlus = () => {
  const dispatch = useDispatch()
  const bonusAmount = useSelector(selectBonusAmount)
  const ticketCount = useSelector(selectSportTypes)
  const sportBonusStatus = useSelector(selectSportBonusStatus)

  useEffect(() => {
    if (sportBonusStatus === 'idle') {
      dispatch(fetchSportBonus())
    }
  }, [dispatch, sportBonusStatus])
  const bonusPlusClick = () => {
    postOpenSportBonusPromo()
  }
  return (
    <div className={styles.bonusPlus} onClick={bonusPlusClick}>
      <div className={styles.bonusTitle}>ბონუს +</div>
      <div className={styles.bonusAmount}>{bonusAmount} ₾</div>
      <div className={styles.bonusProgress}>
        <span style={{ width: `${ticketCount}%` }}></span>
      </div>
      <div className={styles.ticketCount}>{ticketCount}</div>
    </div>
  )
}

export default SportBonusPlus